module.exports = __webpack_public_path__ + "static/media/400013_01.cc00e50f.png";